"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Notification` instead */
export const Notification = createSVGIcon(
  <rect
    x="16"
    y="1"
    width="8"
    height="8"
    rx="4"
    fill="#7D3E1E"
    stroke="#fff"
    strokeWidth="2"
  />,
  "Notification",
  {
    viewBox: "0 0 25 25",
    titleAccess: "Notification",
    fill: "none",
    className: legacyIconCls(),
  }
);
